const t = {
  config: {
    environment: "development",
    loggingEnabled: !1
  },
  initialized: !1
};
Object.freeze(t);
Object.freeze(t.config);
let e = t;
const i = (n) => (e = {
  config: {
    ...t.config,
    ...n
  },
  initialized: !0
}, Object.freeze(e), Object.freeze(e.config), e);
export {
  e as SaasSharedUiQueryContext,
  i as initSaasSharedUiQueryContext
};
